<div class="credit-overview">
  <mat-card appearance="outlined">
  

    <credit-result
      [application]="application"
      [runCreditFlowFn]="runCreditFlowFn"
      [getCreditWebServicesFn]="getCreditWebServicesFn"
      [getApplicationCreditFlowResultFn]="getApplicationCreditFlowResultFn"
      [downloadCreditorWatchReportFn]="downloadCreditorWatchReportFn"
      [updateCreditStatusFn]="updateCreditStatusFn"
      [updateCreditOfficerFn]="updateCreditOfficerFn"
      [getActiveCreditUsersFn]="getActiveCreditUsersFn"
      [getCreditAuditLogFn]="getCreditAuditLogFn"
      [getApplicationByIdFn]="getApplicationByIdFn"
      [getDuplicatedApplicationsFn]="getDuplicatedApplicationsFn"
      [apiUrl]="apiUrl"
      [deleteWebServicesFn]="deleteWebServicesFn"
      [requestMoreInformationFn]="requestMoreInformationFn"
      [getUserFn]="getUserFn"
      [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
      [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
      [createApplicationNoteFn]="createApplicationNoteFn"
      [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
      [getApplicationDscrFn]="getApplicationDscrFn"
      [getHistoricalContractsFn]="getHistoricalContractsFn"
      [getPismoContractsFn]="getPismoContractsFn"
      [getLvrCalculatorValueFn]="getLvrCalculatorValueFn"
      (viewReport)="onViewReport($event)"
      (clickApplicationEvent)="onClick($event)"
      (refreshCreditTabEvent)="refreshCreditTab($event)"
    ></credit-result>
  
  </mat-card>
</div>
